import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { SidebarProvider } from "./components/app/SidebarContext";
import AuthLayout from "./app/(auth)/layout";
import DashboardLayout from "./app/(dashboard)/layout";
import NotFound from "./app/not-found";
import { ROUTES } from "./lib/routes";

const LoginPage = lazy(() => import("./app/(auth)/login/page"));
const ForgotPasswordPage = lazy(
  () => import("./app/(auth)/forgot-password/page"),
);
const VerifyOtpPage = lazy(() => import("./app/(auth)/verify-otp/page"));
const CreatePasswordPage = lazy(
  () => import("./app/(auth)/create-password/page"),
);
const ChangePasswordPage = lazy(
  () => import("./app/(auth)/change-password/page"),
);

const DashboardPage = lazy(() => import("./app/(dashboard)/page"));
const OrderPage = lazy(() => import("./app/(dashboard)/order-management/page"));
const CreateOrderPage = lazy(
  () => import("./app/(dashboard)/order-management/create/page"),
);
const EditOrderPage = lazy(
  () => import("./app/(dashboard)/order-management/[id]/edit/page"),
);
const ViewOrderPage = lazy(
  () => import("./app/(dashboard)/order-management/[id]/page"),
);
const ProductPage = lazy(
  () => import("./app/(dashboard)/product-management/page"),
);
const ViewProductPage = lazy(
  () => import("./app/(dashboard)/product-management/[id]/page"),
);
const ReturnsPage = lazy(() => import("./app/(dashboard)/returns/page"));
const AccountSettingsPage = lazy(
  () => import("./app/(dashboard)/account-settings/page"),
);

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <SidebarProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route
              path={ROUTES.AUTH.LOGIN}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <LoginPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.AUTH.FORGOT_PASSWORD}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ForgotPasswordPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.AUTH.VERIFY_OTP}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <VerifyOtpPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.AUTH.CREATE_PASSWORD}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <CreatePasswordPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.AUTH.CHANGE_PASSWORD}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ChangePasswordPage />
                </Suspense>
              }
            />
          </Route>

          <Route element={<DashboardLayout />}>
            <Route
              path={ROUTES.DASHBOARD.HOME}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <DashboardPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.DASHBOARD.ORDER_MANAGEMENT}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <OrderPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.DASHBOARD.ORDER_CREATE}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <CreateOrderPage />
                </Suspense>
              }
            />
            <Route
              path="/order-management/:id/edit"
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <EditOrderPage />
                </Suspense>
              }
            />
            <Route
              path="/order-management/:id"
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ViewOrderPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.DASHBOARD.PRODUCT_MANAGEMENT}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ProductPage />
                </Suspense>
              }
            />
            <Route
              path="/product-management/:id"
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ViewProductPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.DASHBOARD.RETURNS}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ReturnsPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.DASHBOARD.ACCOUNT_SETTINGS}
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <AccountSettingsPage />
                </Suspense>
              }
            />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </SidebarProvider>
  );
}
